import { FaTaxi } from "react-icons/fa";
import LazyInView from "../../../../Atoms/LazyInView";

// Matches PICKUP_ZONE_MAP_HEIGHT; not imported so the map module stays lazy.
const MAP_HEIGHT = 400;

export type PickupPlaceProps = {
  pickupLocationZone: {
    center: { lat: number; lng: number };
    radius: number;
  } | null;
  showLabel?: boolean;
};
export default function PickupPlace({
  pickupLocationZone,
  showLabel,
}: PickupPlaceProps) {
  return (
    <>
      {showLabel && <p className="DetailTitle">Pickup Area Zone</p>}

      <div style={{ display: "flex", gap: 20 }}>
        <FaTaxi size={40} color={"#d81b60"} />
        <p style={{ marginBottom: 20, fontSize: 14 }}>
          Accomodations within this area zone are eligible for vehicle pickup.
          <br />
          Please enter in your accomodation at checkout.
        </p>
      </div>
      {/* The Maps library and the map load when the map scrolls into view. */}
      <LazyInView
        fallback={
          <div style={{ height: MAP_HEIGHT, backgroundColor: "#f2f2f2" }} />
        }
        loader={() => import("./PickupZoneMap")}
        render={(loaded) => {
          const PickupZoneMap = loaded.default;
          return <PickupZoneMap pickupLocationZone={pickupLocationZone} />;
        }}
      />
    </>
  );
}
